/**
 * PageHeader - Consistent page header with title and description
 *
 * Usage:
 * <PageHeader
 *   title="Dashboard"
 *   description="Monitor your key metrics and performance."
 * />
 */

export interface PageHeaderProps {
  title: string;
  /** @deprecated Use `description` instead */
  subtitle?: string;
  description?: string;
  children?: React.ReactNode;
}

export function PageHeader({ title, description, subtitle, children }: PageHeaderProps) {
  const text = description || subtitle;
  return (
    <div className="space-y-4 w-full">
      <div className="flex flex-col items-stretch gap-3 sm:flex-row sm:items-center sm:justify-between">
        <div>
          <h1 className="text-2xl font-bold tracking-tight sm:text-4xl">
            {title}
          </h1>
          {text && (
            <p className="text-muted-foreground mt-1.5 text-base">
              {text}
            </p>
          )}
        </div>
        {children && (
          <div className="flex w-full items-center gap-2 sm:w-auto">
            {children}
          </div>
        )}
      </div>
    </div>
  );
}
